module.exports = __webpack_public_path__ + "img/pei4.740b3235.png";